import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import wishlistIcon from '@/public/images/icons/dashboard/no-data/wishlist.svg';
import Image from 'next/image';
import { NoDataCardProps } from '@/types/props/components';
import { GiBrokenHeart, GiNothingToSay } from 'react-icons/gi';
import { twMerge } from '@/lib/twMerge';

export default function NoDataCard({ type, includeBorders = true }: NoDataCardProps) {
  const { translate } = useTypedTranslation<CommonEnum>('common');

  if (type === 'authors') {
    return (
      <div
        className={twMerge(
          'tw-hover:bg-gray-100 tw-flex tw-flex-col tw-items-center tw-rounded-lg tw-bg-white tw-px-6 tw-py-12 tw-shadow-sm',
          includeBorders && 'tw-border tw-border-solid tw-border-gray-200'
        )}
      >
        <Image
          src={wishlistIcon}
          alt="No authors"
          width={100}
          height={100}
          className="tw-mx-auto tw-mb-2"
        />
        <div className="tw-mb-2 tw-text-2xl tw-font-bold tw-tracking-tight tw-text-gray-900">
          {translate(CommonEnum.no_data_card_heading_authors)}
        </div>
        <p className="tw-font-normal tw-text-gray-700">
          {translate(CommonEnum.no_data_card_message_authors)}
        </p>
      </div>
    );
  }

  if (type === 'blog') {
    return (
      <div
        className={twMerge(
          'tw-hover:bg-gray-100 tw-flex tw-flex-col tw-items-center tw-rounded-lg tw-bg-white tw-px-6 tw-py-12 tw-shadow-sm',
          includeBorders && 'tw-border tw-border-solid tw-border-gray-200'
        )}
      >
        <Image
          src={wishlistIcon}
          alt="No blog posts"
          width={100}
          height={100}
          className="tw-mx-auto tw-mb-2"
        />
        <div className="tw-mb-2 tw-text-2xl tw-font-bold tw-tracking-tight tw-text-gray-900">
          {translate(CommonEnum.no_data_card_heading_blog)}
        </div>
        <p className="tw-font-normal tw-text-gray-700">
          {translate(CommonEnum.no_data_card_message_blog)}
        </p>
      </div>
    );
  }

  if (type === 'wishlist') {
    return (
      <div
        className={twMerge(
          'tw-hover:bg-gray-100 tw-flex tw-flex-col tw-items-center tw-rounded-lg tw-bg-white tw-px-6 tw-py-12 tw-shadow-sm',
          includeBorders && 'tw-border tw-border-solid tw-border-gray-200'
        )}
      >
        <GiBrokenHeart className="tw-text-4xl tw-text-gray-500" />
        <div className="tw-mt-2 tw-flex tw-flex-col tw-items-center tw-whitespace-nowrap tw-text-center">
          <div className="tw-mb-2 tw-text-2xl tw-font-bold tw-tracking-tight tw-text-gray-900">
            {translate(CommonEnum.no_data_card_heading_wishlist)}
          </div>
          <p className="tw-text-center tw-font-normal tw-text-gray-700">
            {translate(CommonEnum.no_data_card_message_wishlist)}
          </p>
        </div>
      </div>
    );
  }

  if (type === 'notifications') {
    return (
      <div
        className={twMerge(
          'tw-hover:bg-gray-100 tw-flex tw-flex-col tw-items-center tw-rounded-lg tw-bg-white tw-px-6 tw-py-12 tw-shadow-sm',
          includeBorders && 'tw-border tw-border-solid tw-border-gray-200'
        )}
      >
        <GiNothingToSay className="tw-text-4xl tw-text-gray-500" />
        <div className="tw-mt-2 tw-flex tw-flex-col tw-items-center tw-whitespace-nowrap tw-text-center">
          <div className="tw-mb-2 tw-text-2xl tw-font-bold tw-tracking-tight tw-text-gray-900">
            {translate(CommonEnum.no_data_card_heading_notifications)}
          </div>
          <p className="tw-text-center tw-font-normal tw-text-gray-700">
            {translate(CommonEnum.no_data_card_message_notifications)}
          </p>
        </div>
      </div>
    );
  }

  return null;
}
